import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-try-premium',
  standalone: true,
  imports: [],
  templateUrl: './try-premium.component.html',
  styleUrl: './try-premium.component.scss'
})
export class TryPremiumComponent {

  @Output()
  onTryPremiumClick: EventEmitter<any> = new EventEmitter
}
